import { Component,OnInit } from '@angular/core';
import {ImmaginiBattezzatiService} from '../services/immagini-battezzati.service';
import {Immagine} from '../beans/immagine';

@Component({
  selector: 'catalogo-immagini-battezzati-component',
  templateUrl: './catalogo-immagini-battezzati.component.html',
  styleUrls: ['./catalogo-immagini-battezzati.component.css']
})
export class CatalogoImmaginiBattezzatiComponent implements OnInit {
  
  immagini:Immagine[];

  constructor (private immaginiBattezzatiService:ImmaginiBattezzatiService){}

  ngOnInit():void{
  	this.immaginiBattezzatiService.getImmagini().then(immagini=>this.immagini=immagini);
  }
}


// WEBPACK FOOTER //
// /Users/paspao/workspaceForMaven/libri/libriweb/src/app/catalogo/catalogo-immagini-battezzati.component.ts